import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { isFunction } from '../helper/utils/try';
import { globalize, getGlobal } from '../helper/utils/globalize';
/**
 * 根据手机端提供的bridge获取数据
 * @param {*} key bridge方法名
 */

export var jsBridge = function jsBridge(key) {
  return new _Promise(function (resolve, reject) {
    if (getGlobal().H5DeviceSdkBridge === undefined) {
      reject('H5DeviceSdkBridge is undefined');
    }

    var printAkuH5Data = function printAkuH5Data(data) {
      resolve(data);
    };

    var callback = globalize(printAkuH5Data, {
      name: key,
      once: true
    });

    if (key in H5DeviceSdkBridge && isFunction(H5DeviceSdkBridge[key])) {
      try {
        H5DeviceSdkBridge[key]('{}', callback);
      } catch (e) {
        reject('H5DeviceSdkBridge error');
      }
    }
  });
};
/**
 * 判断是否支持H5DeviceSdkBridge
 */

export var isCanUseH5DeviceSdkBridge = function isCanUseH5DeviceSdkBridge() {
  return getGlobal().H5DeviceSdkBridge === undefined ? false : true;
};